import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import SportTags from '../../../../components/SportTags'
import TeacherAvatar from '../../../../components/TeacherCard/TeacherAvatar'
import { Trainer } from '../../VenueProfile.types'

const MAX_NUMBER_OF_SPORT_TAGS = 2

interface Props {
  trainer: Trainer
}

const TrainerCardInfo = ({ trainer }: Props) => {
  return (
    <Stack px={4} gap={{ xs: 2, md: 4 }}>
      <Stack direction="row" alignItems="center" gap={2}>
        <TeacherAvatar imgSrc={trainer.image?.xSmall} name={trainer.nickname} />
        <Text variant="label">{trainer?.nickname}</Text>
      </Stack>
      <SportTags sports={trainer.sports} maxNumberOfVisibleSports={MAX_NUMBER_OF_SPORT_TAGS} />
    </Stack>
  )
}

export default TrainerCardInfo
